export default __webpack_public_path__ + "static/media/ahc_home.00da2dc0.svg";